import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Autosuggest from 'react-autosuggest';
import { fetchAssetsForAutoComplete, resetAssetsForAutoComplete } from '../../actions/asset';
import { STATE_LOADING } from '../../../../ui-lottery/src/utils/async_utils';
import { AssetProps } from '../../props/asset';
import { SearchProps } from '../../props/search';
import { getState } from '../../reducers';
import { getAssetsForAutoComplete } from '../../reducers/assetsForAutoComplete';

import styles from './SuggestSearch.scss';

const propTypes = {
  id: PropTypes.string,
  value: AssetProps,
  placeholder: PropTypes.string,
  query: SearchProps,
  field: PropTypes.string,
  idField: PropTypes.string,
  onChange: PropTypes.func,
  suggestions: PropTypes.arrayOf(PropTypes.shape({})),
  states: PropTypes.objectOf(PropTypes.number),
  onSearch: PropTypes.func,
  onClearSuggestions: PropTypes.func
};

const defaultProps = {
  value: {},
  query: {}
};

export class SuggestSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: get(props, 'value.name', '')
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value && prevProps.value !== this.props.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ searchText: this.props.value.name });
    }
  }

  onSuggestionsFetchRequested({ value: terms }) {
    if (this.props.states.assetsForAutoComplete !== STATE_LOADING) {
      this.props.onSearch({ ...this.props.query, terms });
    }
  }

  onSuggestionsClearRequested() {
    this.props.onClearSuggestions();
  }

  getSuggestionValue(suggestion) {
    return suggestion.name;
  }

  renderSuggestion(suggestion, { isHighlighted }) {
    const className = isHighlighted ? styles.highlighted : '';
    return (
      <div className={className}>
        {this.getSuggestionValue(suggestion)}
      </div>
    );
  }

  onSuggestionSelected(event, { suggestion }) {
    this.props.onChange({ target: { value: suggestion, dataset: { field: this.props.field } } });
    this.props.onChange({ target: { value: suggestion.id, dataset: { field: this.props.idField } } });
  }

  render() {
    const inputProps = {
      id: this.props.id,
      placeholder: this.props.placeholder || '',
      value: this.state.searchText,
      onChange: (event) => this.setState({ searchText: event.target.value }),
      'data-field': this.props.field
    };
    return (
      <Autosuggest
        suggestions={this.props.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion.bind(this)}
        onSuggestionSelected={this.onSuggestionSelected.bind(this)}
        inputProps={inputProps} />

    );
  }
}

SuggestSearch.propTypes = propTypes;
SuggestSearch.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    suggestions: getAssetsForAutoComplete(state),
    states: getState(state, 'assetsForAutoComplete')
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onSearch: fetchAssetsForAutoComplete,
  onClearSuggestions: resetAssetsForAutoComplete
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuggestSearch));
